const $teaser = $('.discount-teaser');
setTimeout(() => $teaser.addClass('show'), 5000);
$teaser.find('a[rel="back"]').on('click', (e) => {
    e.preventDefault();
    $teaser.removeClass('show');
});
$teaser.find('code').on('click', (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(e.target.innerText).then(() => {
        $(e.target).addClass('flash');
        e.target.getBoundingClientRect();
        setTimeout(() => $(e.target).removeClass('flash'));
    });
});
